<template>
  <div class="d-flex flex-row align-center">
    <v-card
      flat
      :class="buttonClasses"
      style="width: 45px"
      class="mr-1 d-flex flex-column align-center justify-center"
    >
      <p class="mb-0 caption">{{ String(dateFormated.month).toUpperCase() }}</p>
      <p class="my-0 subtitle-1">{{ dateFormated.day }}</p>
    </v-card>
    <v-card
      flat
      :class="[buttonClasses, hasClose ? 'justify-center' : 'textStart']"
      style="width: 210px"
      class="d-flex flex-row align-center"
    >
      <div class="d-flex flex-column mr-4">
        <p class="mb-0 label">{{ scheduleLocal }}</p>
        <p class="mb-0 caption">{{ scheduleTime }}</p>
      </div>
      <BaseButton
        v-if="hasClose"
        type-button="tertiary"
        @click="$emit('cancel')"
        svg-icon-name="remove"
      />
    </v-card>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class WithdrawalsButton extends Vue {
  @Prop({
    default: "dateTime",
  })
  typeButton!: string;
  fullDate: any;
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: false }) selected!: boolean;
  @Prop({ default: "" }) scheduleDate!: string;
  @Prop({ default: "" }) scheduleLocal!: string;
  @Prop({ default: "" }) scheduleTime!: string;
  @Prop(Boolean) hasClose: boolean;

  get isXs(): boolean {
    return this.$vuetify.breakpoint.xs;
  }
  get dateFormated() {
    return (this.fullDate = this.formatDateParts(this.scheduleDate));
  }

  get buttonClasses(): string[] {
    const classes = ["new-base-button", `new-base-button--${this.typeButton}`];
    return classes;
  }

  formatDateParts(date: any) {
    const [year, month, day] = date.split(/[/-]/);
    const months = [
      "jan",
      "feb",
      "mar",
      "apr",
      "may",
      "jun",
      "jul",
      "aug",
      "sep",
      "oct",
      "nov",
      "dec",
    ];
    return {
      month: months[Number(month) - 1],
      year,
      day,
    };
  }
}
</script>

<style lang="sass" scoped>
.new-base-button
  display: inline-flex
  justify-content: center
  align-items: center
  border: none
  outline: none
  cursor: pointer
  font-family: "Open Sans", sans-serif
  font-style: normal
  font-weight: 700
  line-height: normal
  text-align: center
  box-sizing: border-box
  appearance: none
  -webkit-appearance: none
  transition: background 0.5s ease, box-shadow 0.5s ease, color 0.5s ease, border-color 0.5s ease

  // ========================
  // SIZE: smAndUp (>=600px)
  // ========================
  &--sm-and-up
    height: 40px
    padding: 16px
    border-radius: 16px
    font-size: 14px

  // ========================
  // SIZE: xs (<600px)
  // ========================
  &--xs
    height: 28px
    padding: 16px 8px
    border-radius: 10px
    font-size: 12px
    padding: 8px 16px
    border-radius: 8px
    height: 38px

  // ========================
  // TYPE: DATETIME
  // ========================
  &--dateTime
    border: 1px solid transparent
    height: 54px !important
    font-style: normal
    font-weight: 400
    line-height: normal
    background: var(--v-purplePale-base)

    &:disabled
      background: var(--v-gray35-base)
      color: var(--v-purpleSecondary-base)
      cursor: not-allowed
      box-shadow: none

    &:hover:not(:disabled)
      border-color: var(--v-purpleBrand-base)
      background: var(--v-purplePale-base)

    &:active:not(:disabled)
      box-shadow: 0 2px 4px 0 var(--v-purpleShadow-base) inset

    &:focus-visible:not(:disabled)
      border: 2px solid var(--v-purple100-base)
      color: var(--v-purple100-base)

    // --- DATETIME SELECTED (ATIVO) ---
    &.new-base-button--selected
      background: var(--v-purplePale-base)
      color: var(--v-purpleBrand-base)

.textStart
  text-align: start !important
  align-items: flex-start !important
  justify-content: start !important
  padding: 8px 16px !important
</style>
